/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */

export enum CCProcessorEnum {
    NONE = 'None',
    PACE_EVEREST = 'Pace_Everest',
    PNP = 'PNP',
    PACE_TRANSAFE = 'Pace_Transafe',
    THIRD_PARTY = 'Third_Party',
    I3PAY_FAC = 'i3PayFac',
}